import React from 'react';
import { Rocket, Users, TrendingUp, Zap } from 'lucide-react';

const WhyTraain = () => {
  const reasons = [
    {
      icon: Rocket,
      title: 'Mission-Driven Work',
      description: 'We are solving real problems that help companies build better teams and accelerate careers. Every line of code has measurable impact.'
    },
    {
      icon: Users,
      title: 'World-Class Team',
      description: 'Work alongside talented engineers, designers, and product leaders from top tech companies. Learn from the best.'
    },
    {
      icon: TrendingUp,
      title: 'Massive Growth',
      description: 'Join us at an exciting inflection point. We are scaling fast, and early team members will shape our trajectory.'
    },
    {
      icon: Zap,
      title: 'Cutting-Edge AI',
      description: 'Work with the latest AI/ML technologies. Build products that push the boundaries of what is possible in talent intelligence.'
    }
  ];

  return (
    <section id="why-traain" className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            Why Traain?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We are building something special. Here is what makes Traain different.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-2xl p-8 border border-gray-800 hover:border-gray-700 transition-all"
            >
              <div className="w-14 h-14 bg-blue-900/30 border border-blue-700 rounded-xl flex items-center justify-center mb-6">
                <reason.icon className="w-7 h-7 text-blue-400" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{reason.title}</h3>
              <p className="text-gray-400">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTraain;